import React, { ReactNode } from 'react'
import { Stack } from '@mui/material'

type IconTileProps = {
  icon: ReactNode
}

const IconTile = ({ icon }: IconTileProps) => {
  return (
    <Stack
      sx={{
        width: 40,
        height: 40,
        bgcolor: 'background.elevation2',
        color: 'text.lighter',
        borderRadius: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        '& svg': {
          color: 'text.base',
          width: 18,
          height: 18,
        },
      }}
    >
      {icon}
    </Stack>
  )
}

export default IconTile
